// extracted by mini-css-extract-plugin
export var hideEditor = "_jx-2";
export var infoIcon = "_jx-3";
export var label = "_jx-1";
export var labelContainer = "_jx-0";
export var readonlyText = "_jx-4";